module.exports = __webpack_public_path__ + "static/img/image_news_over_04.38c77f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_over_04.png
// module id = uNoJ
// module chunks = 10